<template>
  <div class="pages member">
    <div class="container">
      <h1>画世界{{isHsjPro() ? 'Pro' : '' }}人脸验证服务协议</h1>
      <p class="top__desc">欢迎使用人脸验证服务!</p>
      <p class="top__desc">
        为使用人脸验证服务（以下称“本服务”），更好地保障你的权益，<strong
          >你应当阅读并遵守《人脸验证服务协议》（以下称“本协议”），同时遵守《“画世界{{isHsjPro() ? 'Pro' : '' }}”用户服务协议》
          《“画世界{{isHsjPro() ? 'Pro' : '' }}”隐私政策》
          、以及画世界{{isHsjPro() ? 'Pro' : '' }}平台不时公布的其它各项制度规范。</strong
        >
      </p>
      <p class="top__desc">
        <strong
          >画世界{{isHsjPro() ? 'Pro' : '' }}已经以字体加粗或其他合理方式提示用户重点阅读协议中相关免除或限制责任条款，用户和画世界{{isHsjPro() ? 'Pro' : '' }}均认可其合法性及有效性。如你不同意本协议，或拒绝提供个人信息进行人脸验证，这将导致我们无法为你提供完整的产品和服务，你也可以选择停止使用。如你自主选择同意或使用本服务，则视为你已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与本服务相关的协议和规则的约束。</strong
        >
      </p>
      <ol class="main-list">
        <li>
          <h2>定义</h2>
          <ol>
            <li>
              平台：本协议所称"平台"是指石家庄幻刺网络科技有限公司（以下简称“公司”）。
            </li>
            <li>
              人脸验证服务：是指由平台或平台指定的第三方机构提供的，通过人脸信息比对，核验用户身份，并将认证结果及认证相关信息反馈至向你提供产品或服务的主体。
            </li>
          </ol>
        </li>

        <li>
          <h2>个人信息处理与用途</h2>
          <ol>
            <li>
              为对申请实名认证的画世界{{isHsjPro() ? 'Pro' : '' }}帐号进行审核和安全验证，你同意使用公司提供的人脸验证服务，即公司通过人脸信息比对核验你的身份，以确保帐号实际使用人和帐号实名认证人为同一人。
            </li>
            <li>
              <strong>
                请您理解，为实现认证目的，画世界{{isHsjPro() ? 'Pro' : '' }}会将您的实名信息共享至第三方合作伙伴【腾讯】进行认证，画世界{{isHsjPro() ? 'Pro' : '' }}会和对方严格保障您的信息安全。您根据画世界{{isHsjPro() ? 'Pro' : '' }}提示点击“同意”即视为您同意向画世界{{isHsjPro() ? 'Pro' : '' }}提供您的身份信息，并同意画世界{{isHsjPro() ? 'Pro' : '' }}将您的实名信息传输给第三方。
              </strong>
            </li>
            <li>
              <strong>
                你承诺提供的信息合法、有效、真实、准确并完整，不采取任何违法违规、不正当或欺骗手段使用人脸验证服务。
              </strong>
            </li>
            <li>
              公司将严格按照法律法规与《“画世界{{isHsjPro() ? 'Pro' : '' }}”隐私政策》保护你的信息。
            </li>
          </ol>
        </li>
        <li>
          <h2>用户使用须知</h2>

          <ol>
            <li>
              <strong>
                我们努力在现有技术能力基础上保障人脸验证服务有效、稳定运行，但是，由于技术的限制，以及采集人脸信息过程中容易受到环境光线、表情、妆容等不特定因素的影响，公司暂时无法保证每次人脸验证都能成功。
              </strong>
            </li>
            <li>
              通过身份信息识别的画世界{{isHsjPro() ? 'Pro' : '' }}用户不能自行修改已经认证的信息，包括但不限于姓名以及身份证件号码等。
            </li>
            <li>
              为保护你或他人的合法权益，公司有权在认为可能存在风险时暂停向你提供人脸验证相关服务。
            </li>
            <li>
              对我们与之共享你个人信息的第三方，该些第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估并要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该些信息。
            </li>
          </ol>
        </li>
        <li>
          <h2>附则</h2>

          <ol>
            <li>
              为给你提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，公司会适时对本协议进行修订，平台将不定期对本协议进行修订，并根据相关法律法规进行公示。如你对修订后的内容存有异议的，请立即停止使用本服务。若你知晓并继续使用“画世界{{isHsjPro() ? 'Pro' : '' }}”软件及相关服务，即视为你认可并接受修订后的本管理规范内容。
            </li>
            <li>
              用户应遵守国家法律法规及相关部门规章制度等规范性文件。对任何涉嫌违反国家法律法规、行政法规及相关部门规范的行为，本协议已有约定的适用本协议，本协议尚未涉及的，平台有权酌情处理，但不免除用户应承担的法律责任。用户在平台的全部行为，都应同时遵守与平台及其关联公司签订的各项协议及规则。
            </li>
            <li>
              本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。
            </li>
          </ol>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { testApp } from '@/utils';
export default {
  name: "Member",
  components: {},
  computed: {},
  created() {},
  methods: {
    testApp,
    isHsjPro() {
      return this.testApp('hsjpro');
    }
  },
};
</script>

<style lang="scss">
.member {
  .container {
    h1 {
      font-size: 24px;
    }
    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }
    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .third-url-list {
      > a {
        display: block;
      }
    }
    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;
        + ol {
          margin-top: 15px;
        }
      }
      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
      a {
        color: #1989fa;
        text-decoration: none;
      }
    }
  }
  .sdk-table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
        &:first-child,
        &:last-child {
          width: 80px;
        }
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: center;
    }
  }
}
</style>
